import React from 'react';
import { useSeasonContext } from './SeasonContext';
import ParticleEffect from './particles/ParticleEffect';
import FlyingElement from './flying/FlyingElement';

interface SeasonalThemeProps {
    particleDuration?: number; // Duration in seconds before particles fade (0 = infinite)
}

const SeasonalTheme: React.FC<SeasonalThemeProps> = ({ particleDuration = 0 }) => {
    const { config } = useSeasonContext();

    return (
        <>
            <ParticleEffect config={config.particles} duration={particleDuration} />
            {config.flying && <FlyingElement config={config.flying} />}
        </>
    );
};

export default SeasonalTheme;
